import { render } from "./StoriesList.vue?vue&type=template&id=893d4b36"
import script from "./StoriesList.vue?vue&type=script&lang=js"
export * from "./StoriesList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__